<template>
	<div class="chat-box" @click="closeRefBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="64px">
				<div class="header-main">
					<div class="header-title">{{ displayTitle }}</div>
					<div v-if="isVisitorSession" class="header-meta">{{ customerMetaText }}</div>
					<div v-if="typingStatusText" class="header-typing">{{ typingStatusText }}</div>
				</div>
				<div class="header-actions">
					<el-tag v-if="isHistorySession" size="mini" type="info">历史会话</el-tag>
					<el-button v-if="isVisitorSession" size="mini" plain @click="editCustomerRemark">备注客户</el-button>
					<el-button v-if="canBlacklistSession" size="mini" type="warning" plain @click="blacklistSession">拉黑客户</el-button>
					<el-button v-if="canEndSession" size="mini" type="danger" plain @click="endSession">结束会话</el-button>
					<span title="群聊信息" v-show="isGroup" class="btn-side el-icon-more" @click="showSide = !showSide"></span>
				</div>
			</el-header>
			<el-main style="padding: 0;">
				<el-container>
					<el-container class="content-box">
						<el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
							<div class="im-chat-box">
								<div v-for="(msgInfo, idx) in showMessages" :key="showMinIdx + idx">
									<chat-message-item @call="onCall(msgInfo.type)" :mine="msgInfo.sendId == mine.id"
										:headImage="headImage(msgInfo)" :showName="showName(msgInfo)" :msgInfo="msgInfo"
										:groupMembers="groupMembers" @resend="onResendMessage" @delete="deleteMessage"
										@recall="recallMessage">
									</chat-message-item>
								</div>
							</div>
						</el-main>
						<div v-if="!isInBottom" class="scroll-to-bottom" @click="scrollToBottom">
							{{ newMessageSize > 0 ? newMessageSize + '条新消息' : '回到底部' }}
						</div>
						<el-footer :height="isMobileLayout ? '136px' : '220px'" class="im-chat-footer">
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="发送图片">
									<file-upload :action="'/image/upload'" :maxSize="5 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="10 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div title="回执消息" v-show="isGroup" class="icon iconfont icon-receipt"
									:class="isReceipt ? 'chat-tool-active' : ''" @click="onSwitchReceipt">
								</div>
								<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<div title="语音通话" v-show="isPrivate" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="语音通话" v-show="isGroup" class="el-icon-phone-outline"
									@click="onGroupVideo()">
								</div>
								<div title="视频通话" v-show="isPrivate" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()"></div>
							</div>
							<div class="send-content-area">
								<ChatInput :ownerId="group.ownerId" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" @typing="onInputTypingChange" />
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion"
										@click="notifySend()">发送</el-button>
								</div>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="side-box quick-reply-box" width="280px" v-if="showQuickReplySide">
						<chat-quick-reply-side @select="applyCommonPhrase"></chat-quick-reply-side>
					</el-aside>
					<el-aside class="side-box" width="320px" v-if="showSide">
						<chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)">
						</chat-group-side>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector ref="rtcSel" :group="group" @complete="onInviteOk"></group-member-selector>
			<rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
				:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
		</el-container>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatQuickReplySide from "./ChatQuickReplySide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";


export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		ChatQuickReplySide,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin
	},
	props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			userInfo: {},
			group: {},
			groupMembers: [],
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
			isReceipt: true,
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			showHistory: false, // 是否显示历史聊天记录
			lockMessage: false, // 是否锁定发送，
			showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡置
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发消息
			isInBottom: false, // 滚动条是否在底部
			newMessageSize: 0, // 滚动条不在底部时新的消息数量
			maxTmpId: 0, // 最后生成的临时ID
			peerTypingVisible: false,
			peerTypingTimer: null,
			typingActive: false,
			lastTypingAt: 0,
			viewportWidth: typeof window === 'undefined' ? 1200 : window.innerWidth
		}
	},
	methods: {
		handleViewportResize() {
			this.viewportWidth = window.innerWidth;
		},
		buildDialogOptions(options = {}, prompt = false) {
			if (!this.isMobileLayout) {
				return options;
			}
			const customClass = prompt ? 'chat-mobile-message-box chat-mobile-prompt' : 'chat-mobile-message-box';
			return {
				...options,
				customClass,
				closeOnClickModal: false,
				closeOnPressEscape: true
			};
		},
		moveChatToTop() {
			let chatIdx = this.chatStore.findChatIdx(this.chat);
			this.chatStore.moveTop(chatIdx);
		},
		closeRefBox() {
			this.$refs.emoBox.close();
			// this.$refs.atBox.close();
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		onImageSuccess(data, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		onImageFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.IMAGE,
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.SENDING
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象保存
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			// 更新图片尺寸
			let chat = this.chat;
			this.getImageSize(file).then(size => {
				data.width = size.width;
				data.height = size.height;
				msgInfo.content = JSON.stringify(data)
				this.chatStore.updateMessage(msgInfo, chat);
				this.scrollToBottom();
			})
		},
		onFileSuccess(url, file) {
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		onFileFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.FILE,
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.SENDING
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		onCloseSide() {
			this.showSide = false;
		},
		onScrollToTop() {
			// 多展示10条信息
			this.showMinIdx = this.showMinIdx > 10 ? this.showMinIdx - 10 : 0;
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				// 多展示20条信息
				this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				this.isInBottom = false;
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				this.isInBottom = true;
				this.newMessageSize = 0;
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		onInputTypingChange({ typing, force }) {
			this.notifyPrivateTyping(typing, force);
		},
		notifyPrivateTyping(typing, force = false, targetId = null) {
			if (!this.isPrivate) {
				return;
			}
			const recvId = targetId || (this.chat && this.chat.targetId);
			if (!recvId) {
				return;
			}
			const now = Date.now();
			if (typing) {
				if (!force && this.typingActive && now - this.lastTypingAt < 2500) {
					return;
				}
				this.typingActive = true;
				this.lastTypingAt = now;
			} else {
				if (!this.typingActive && !force) {
					return;
				}
				this.typingActive = false;
				this.lastTypingAt = 0;
			}
			this.$http({
				url: '/message/private/typing',
				method: 'post',
				data: {
					recvId,
					typing: !!typing
				}
			}).catch(() => {});
		},
		handlePrivateTypingEvent({ friendId, typing }) {
			if (!this.chat || !this.isPrivate || friendId !== this.chat.targetId) {
				return;
			}
			if (!typing) {
				this.clearPeerTypingTimer();
				this.peerTypingVisible = false;
				return;
			}
			this.peerTypingVisible = true;
			this.clearPeerTypingTimer();
			this.peerTypingTimer = setTimeout(() => {
				this.peerTypingVisible = false;
				this.peerTypingTimer = null;
			}, 4000);
		},
		clearPeerTypingTimer() {
			if (this.peerTypingTimer) {
				clearTimeout(this.peerTypingTimer);
				this.peerTypingTimer = null;
			}
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}

			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 邀请成员发起通话
			let ids = [this.mine.id];
			let maxChannel = this.configStore.webrtc.maxChannel;
			this.$refs.rtcSel.open(maxChannel, ids, ids, []);
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.showHistory = true;
		},
		closeHistoryBox() {
			this.showHistory = false;
		},
		onSendRecord(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let msgInfo = {
				tmpId: this.generateId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.AUDIO,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 临时消息回显	
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			this.sendMessageRequest(msgInfo).then(m => {
				// 更新消息
				tmpMessage.id = m.id;
				tmpMessage.status = m.status;
				this.chatStore.updateMessage(tmpMessage, chat);
				// 会话置顶
				this.moveChatToTop();
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			}).catch(() => {
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, this.chat);
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.chat.type == "GROUP") {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		applyCommonPhrase(content) {
			if (!content || !content.trim()) {
				return;
			}
			this.$refs.chatInputEditor.insertText(content.trim());
			this.$refs.chatInputEditor.focus();
		},
		async sendMessage(fullList) {
			this.resetEditor();
			this.readedMessage();
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let sendText = this.isReceipt ? "【回执消息】" : "";
			fullList.forEach(async msg => {
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}
			})
		},
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				let formData = new FormData()
				formData.append('file', file)
				this.$http.post("/image/upload?isPermanent=false", formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((data) => {
					this.onImageSuccess(data, file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				if (!sendText.trim()) {
					reject();
				}
				let msgInfo = {
					tmpId: this.generateId(),
					content: sendText,
					type: this.$enums.MESSAGE_TYPE.TEXT
				}
				// 填充对方id
				this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				if (this.chat.type == "GROUP") {
					msgInfo.atUserIds = atUserIds;
					msgInfo.receipt = this.isReceipt;
				}
				this.lockMessage = true;
				// 防止发送期间用户切换会话导致串扰
				const chat = this.chat;
				// 回显消息
				let tmpMessage = this.buildTmpMessage(msgInfo);
				this.chatStore.insertMessage(tmpMessage, chat);
				this.moveChatToTop();
				// 发送
				this.sendMessageRequest(msgInfo).then((m) => {
					// 更新消息
					tmpMessage.id = m.id;
					tmpMessage.status = m.status;
					tmpMessage.content = m.content;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).catch(() => {
					// 更新消息
					tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).finally(() => {
					this.isReceipt = false;
					resolve();
				});
			});
		},
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
				}
			})
		},
		onResendMessage(msgInfo) {
			if (msgInfo.type != this.$enums.MESSAGE_TYPE.TEXT) {
				this.$message.error("该消息不支持自动重新发送，建议手动重新发送")
				return;
			}
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 删除旧消息
			this.chatStore.deleteMessage(msgInfo, chat);
			// 重新推送
			msgInfo.tmpId = this.generateId();
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			this.sendMessageRequest(msgInfo).then(m => {
				// 更新消息
				tmpMessage.id = m.id;
				tmpMessage.status = m.status;
				tmpMessage.content = m.content;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				// 更新消息
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).finally(() => {
				this.scrollToBottom();
			});
		},
		deleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.chatStore.deleteMessage(msgInfo, this.chat);
			});
		},
		recallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					m.selfSend = true;
					this.chatStore.recallMessage(m, this.chat);
				})
			});
		},
		readedMessage() {
			if (this.chat.unreadCount > 0) {
				if (this.isGroup) {
					var url = `/message/group/readed?groupId=${this.chat.targetId}&messageId=${this.maxMessageId}`
				} else {
					url = `/message/private/readed?friendId=${this.chat.targetId}`
				}
				this.$http({
					url: url,
					method: 'put'
				}).then(() => { })
				this.chatStore.resetUnreadCount(this.chat)
			}
		},
		loadReaded(fId) {
			this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			}).then((id) => {
				this.chatStore.readedMessage({
					friendId: fId,
					maxId: id
				});
			});
		},
		loadGroup(groupId) {
			this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			}).then((group) => {
				this.group = group;
				this.chatStore.updateChatFromGroup(group);
				this.groupStore.updateGroup(group);
			});

			this.$http({
				url: `/group/members/${groupId}`,
				method: 'get'
			}).then((groupMembers) => {
				this.groupMembers = groupMembers;
			});
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			} else {
				this.chatStore.updateChatFromUser(this.userInfo);
			}
		},
		loadFriend(friendId) {
			// 获取好友信息
			this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		showName(msgInfo) {
			if (!msgInfo) {
				return ""
			}
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : msgInfo.sendNickName || "";
			} else {
				return msgInfo.selfSend ? this.mine.nickName : this.chat.showName
			}
		},
		headImage(msgInfo) {
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "【回执消息】"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.ensureSessionAvailable().then(() => this.$http({
					url: this.messageAction,
					method: 'post',
					data: reqData.msgInfo
				})).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.type == "PRIVATE") {
				msgInfo.recvId = this.mine.id
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.userInfo.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.chatStore.insertMessage(msgInfo, this.chat);
		},
		endSession() {
			if (!this.canEndSession) {
				return;
			}
			this.$confirm(`确认结束与'${this.chat.showName}'的会话吗？`, '结束会话', this.buildDialogOptions({
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})).then(() => {
				this.$http({
					url: '/agent/session/end',
					method: 'post',
					data: {
						sessionId: this.chat.sessionId
					}
				}).then(() => {
					this.chat.sessionStatus = 2;
					this.chatStore.updateChatMeta(this.chat, {
						sessionStatus: 2
					});
					this.$message.success('会话已归档');
					this.$emit('session-ended', this.chat);
				});
			});
		},
		blacklistSession() {
			if (!this.canBlacklistSession) {
				return;
			}
			this.$confirm(
				`确认拉黑'${this.chat.showName}'吗？拉黑后该客户无法再通过当前代理渠道建立连接，且不会影响其他代理。`,
				'拉黑客户',
				this.buildDialogOptions({
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
			).then(() => {
				this.$http({
					url: '/agent/session/blacklist',
					method: 'post',
					data: {
						sessionId: this.chat.sessionId
					}
				}).then(() => {
					this.$message.success('客户已拉黑');
					this.$emit('session-blacklisted', this.chat);
				});
			});
		},
		editCustomerRemark() {
			if (!this.isVisitorSession) {
				return;
			}
			this.$prompt('请输入客户备注', '备注客户', this.buildDialogOptions({
				confirmButtonText: '保存',
				cancelButtonText: '取消',
				inputValue: this.chat.visitorRemark || '',
				inputPlaceholder: '例如：官网投放-张三',
				inputValidator: (value) => {
					if (value && value.length > 64) {
						return '备注长度不能超过64个字符';
					}
					return true;
				}
			}, true)).then(({ value }) => {
				this.$http({
					url: '/agent/customer/remark',
					method: 'put',
					data: {
						visitorUserId: this.chat.targetId,
						remark: value || ''
					}
				}).then(() => {
					const nextName = value || this.chat.visitorNickName || this.chat.visitorUserName || this.chat.showName;
					this.chat.visitorRemark = value || '';
					this.chat.showName = nextName;
					this.chatStore.updateChatMeta(this.chat, {
						visitorRemark: value || '',
						showName: nextName
					});
					const friend = this.friendStore.findFriend(this.chat.targetId);
					if (friend) {
						this.friendStore.updateFriend({
							...friend,
							remarkNickName: value || '',
							showNickName: value || friend.nickName
						});
					}
					this.$message.success('客户备注已更新');
					this.$emit('customer-remark-updated', this.chat);
				});
			}).catch(() => {});
		},
		ensureSessionAvailable() {
			if (!this.isHistorySession || !this.chat.sessionId) {
				return Promise.resolve();
			}
			return this.$http({
				url: '/agent/session/reopen',
				method: 'post',
				data: {
					sessionId: this.chat.sessionId
				}
			}).then(() => {
				this.chat.sessionStatus = 1;
				this.chatStore.updateChatMeta(this.chat, {
					sessionStatus: 1
				});
				this.$emit('session-reopened', this.chat);
			});
		},
		buildTmpMessage(msgInfo) {
			let message = JSON.parse(JSON.stringify(msgInfo));
			message.sendId = this.mine.id;
			message.sendTime = new Date().getTime();
			message.status = this.$enums.MESSAGE_STATUS.SENDING;
			message.selfSend = true;
			if (this.isGroup) {
				message.readedCount = 0;
			}
			return message;
		},
		getImageSize(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = function (event) {
					const img = new Image();
					img.onload = function () {
						resolve({ width: img.width, height: img.height });
					};
					img.onerror = function () {
						reject(new Error('无法加载图片'));
					};
					img.src = event.target.result;
				};
				reader.onerror = function () {
					reject(new Error('无法读取文件'));
				};
				reader.readAsDataURL(file);
			});
		},
		generateId() {
			// 生成临时id 
			const id = String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
			// 必须保证id是递增
			if (this.maxTmpId > id) {
				return this.generateId();
			}
			this.maxTmpId = id;
			return id;
		}
	},
	computed: {
		isMobileLayout() {
			return this.viewportWidth <= 900;
		},
		mine() {
			return this.userStore.userInfo;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friend() {
			return this.friendStore.findFriend(this.userInfo.id)
		},
		title() {
			let title = this.chat.showName;
			if (this.chat.type == "GROUP") {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			return title;
		},
		displayTitle() {
			return this.chat.visitorRemark || this.title;
		},
		customerMetaText() {
			const parts = [];
			const rawName = this.chat.visitorNickName || this.chat.visitorUserName;
			if (this.chat.visitorRemark && rawName) {
				parts.push(`原名: ${rawName}`);
			} else if (rawName) {
				parts.push(rawName);
			}
			if (this.chat.clientIp) {
				parts.push(`IP: ${this.chat.clientIp}`);
			}
			if (this.chat.clientRegion) {
				parts.push(this.chat.clientRegion);
			}
			return parts.join(' | ');
		},
		typingStatusText() {
			return this.isPrivate && this.peerTypingVisible ? '对方正在输入...' : '';
		},
		messageAction() {
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		showMessages() {
			return this.chat.messages.slice(this.showMinIdx)
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isBanned() {
			return (this.chat.type == "PRIVATE" && this.userInfo.isBanned) ||
				(this.chat.type == "GROUP" && this.group.isBanned)
		},
		memberSize() {
			return this.groupMembers.filter(m => !m.quit).length;
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		isPrivate() {
			return this.chat.type == 'PRIVATE';
		},
		isHistorySession() {
			return this.isPrivate && this.chat.isVisitorSession && this.chat.sessionStatus == 2;
		},
		isVisitorSession() {
			return this.isPrivate && this.chat.isVisitorSession;
		},
		canEndSession() {
			return this.isVisitorSession && this.chat.sessionStatus != 2;
		},
		canBlacklistSession() {
			return this.isVisitorSession && !!this.chat.sessionId;
		},
		showQuickReplySide() {
			return this.isPrivate && !this.isMobileLayout;
		},
		loading() {
			return this.chatStore.loading;
		},
		maxMessageId() {
			for (let idx = this.chat.messages.length - 1; idx >= 0; idx--) {
				const message = this.chat.messages[idx];
				if (message.id) {
					return message.id;
				}
			}
			return 0;
		},
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				if (oldChat && oldChat.type == "PRIVATE" && oldChat.targetId && this.typingActive) {
					this.notifyPrivateTyping(false, true, oldChat.targetId);
				}
				this.clearPeerTypingTimer();
				this.peerTypingVisible = false;
				this.typingActive = false;
				this.lastTypingAt = 0;
				if (newChat.targetId > 0 && (!oldChat || newChat.type != oldChat.type ||
					newChat.targetId != oldChat.targetId)) {
					this.userInfo = {}
					this.group = {};
					this.groupMembers = [];
					if (this.chat.type == "GROUP") {
						this.loadGroup(this.chat.targetId);
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
					}
					// 滚到底部
					this.scrollToBottom();
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					// 初始状态只显示30条消息
					let size = this.chat.messages.length;
					this.showMinIdx = size > 30 ? size - 30 : 0;
					// 重置输入框
					this.resetEditor();
					// 复位回执消息
					this.isReceipt = false;
					// 清空消息临时id
					this.maxTmpId = 0;
					// 更新placeholder
					this.refreshPlaceHolder();
				}
			},
			immediate: true
		},
		messageSize: {
			handler(newSize, oldSize) {
				if (newSize > oldSize) {
					// 收到普通消息,则滚动至底部
					let lastMessage = this.chat.messages[newSize - 1];
					if (lastMessage && this.$msgType.isNormal(lastMessage.type)) {
						if (this.isInBottom || lastMessage.selfSend) {
							this.scrollToBottom();
						} else {
							this.newMessageSize++;
						}
					}
				}
			}
		},
		loading: {
			handler(newLoading, oldLoading) {
				// 断线重连后，需要更新一下已读状态
				if (!newLoading && this.isPrivate) {
					this.loadReaded(this.chat.targetId)
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
		this.$eventBus.$on('privateTyping', this.handlePrivateTypingEvent);
		this.handleViewportResize();
		window.addEventListener('resize', this.handleViewportResize);
	},
	beforeDestroy() {
		if (this.chat && this.chat.type == "PRIVATE" && this.chat.targetId && this.typingActive) {
			this.notifyPrivateTyping(false, true, this.chat.targetId);
		}
		this.clearPeerTypingTimer();
		this.$eventBus.$off('privateTyping', this.handlePrivateTypingEvent);
		window.removeEventListener('resize', this.handleViewportResize);
	}
}
</script>

<style lang="scss" scoped>
.chat-box {
	position: relative;
	width: 100%;
	height: 100%;
	background: #fff;

	:deep(.el-container) {
		height: 100%;
		min-height: 0;
	}

	:deep(.el-main),
	:deep(.el-footer) {
		min-height: 0;
	}

	.el-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 12px;
		border-bottom: var(--im-border);

		.header-main {
			flex: 1;
			min-width: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			padding: 8px 0;
		}

		.header-title {
			font-size: var(--im-font-size-larger);
			line-height: 22px;
			font-weight: 600;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.header-meta {
			margin-top: 4px;
			color: var(--im-text-color-light);
			font-size: var(--im-font-size-small);
			line-height: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.header-typing {
			margin-top: 4px;
			color: #4f7cff;
			font-size: var(--im-font-size-small);
			line-height: 18px;
			white-space: nowrap;
		}

		.header-actions {
			display: flex;
			align-items: center;
			gap: 8px;
			margin-left: 12px;
		}

		.btn-side {
			line-height: 1;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}
	}

	.content-box {
		position: relative;
		min-height: 0;

		.im-chat-main {
			padding: 0;
			min-height: 0;
			background-color: #f4f5f6;

			.im-chat-box {
				>ul {
					padding: 0 20px;

					li {
						list-style-type: none;
					}
				}
			}
		}

		.scroll-to-bottom {
			text-align: right;
			position: absolute;
			right: 20px;
			bottom: 230px;
			color: var(--im-color-primary);
			font-size: var(--im-font-size);
			font-weight: 600;
			background: #eee;
			padding: 5px 15px;
			border-radius: 15px;
			cursor: pointer;
			z-index: 99;
			box-shadow: var(--im-box-shadow-light);
		}

		.im-chat-footer {
			display: flex;
			flex-direction: column;
			padding: 0;
			flex-shrink: 0;

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 44px;
				text-align: left;
				box-sizing: border-box;
				border-top: 2px solid #EBEEF5;
				padding: 6px 8px;
				align-items: center;
				background: var(--im-background-active);
				color: black;
				gap: 8px;
				opacity: 0.85;

				// 统一所有按钮的样式，参考新版本
				>div {
					font-size: 20px;
					cursor: pointer;
					width: 32px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					border-radius: 6px;
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

					&.chat-tool-active {
						color: var(--im-color-primary);
						background: var(--im-background-active-dark);
						transform: scale(1.02);
					}

					&:hover {
						color: var(--im-color-primary);
						background: var(--im-background-active);
						transform: translateY(-1px);
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					}
				}
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				min-height: 0;
				background-color: white !important;

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}
			}
		}
	}

	.side-box {
		border-left: var(--im-border);
	}

	.quick-reply-box {
		flex-shrink: 0;
	}
}

@media (max-width: 900px) {
	.chat-box {
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 0;
		overflow: hidden;

		:deep(.el-container) {
			height: 100%;
			min-height: 0;
		}

		.el-header {
			height: auto !important;
			flex-shrink: 0;
			padding: 6px 10px;
			align-items: flex-start;
			gap: 8px;

			.header-actions {
				margin-left: 0;
				gap: 6px;
				flex-wrap: wrap;
				justify-content: flex-end;
			}
		}

		.content-box {
			height: 100%;
			min-height: 0;
			display: flex;
			flex-direction: column;
			overflow: hidden;

			.scroll-to-bottom {
				right: 10px;
				bottom: 166px;
				padding: 4px 10px;
			}

			.im-chat-footer {
				height: 136px !important;
				position: relative;
				flex-shrink: 0;
				overflow: hidden;

				.chat-tool-bar {
					overflow-x: auto;
					white-space: nowrap;
					gap: 6px;
					padding: 6px;

					>div {
						flex: 0 0 auto;
					}
				}

				.send-content-area {
					position: relative;
					height: 92px;
					padding: 6px 92px calc(env(safe-area-inset-bottom) + 6px) 8px;
					box-sizing: border-box;
					overflow: hidden;

					:deep(.chat-input-area) {
						width: 100%;
						height: 100%;
						min-width: 0;
						border: 1px solid #e7ebf0;
						border-radius: 8px;
						background: #fff;
					}

					:deep(.edit-container) {
						padding: 6px 8px;
						line-height: 22px;
					}

					.send-btn-area {
						position: absolute;
						right: 8px;
						bottom: calc(env(safe-area-inset-bottom) + 10px);
						padding: 0;
						z-index: 3;

						.el-button {
							padding: 7px 12px;
							white-space: nowrap;
						}
					}
				}
			}
		}
	}
}

</style>

<style lang="scss">
.chat-mobile-message-box {
	width: 90vw !important;
	max-width: 330px;
	max-height: calc(100dvh - 24px);
	margin-top: 12px !important;
	overflow: hidden;

	.el-message-box__content {
		max-height: calc(100dvh - 180px);
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		word-break: break-word;
	}

	.el-message-box__btns {
		display: flex;
		justify-content: flex-end;
		gap: 8px;
	}
}

.chat-mobile-prompt {
	width: 84vw !important;
	max-width: 300px;

	.el-message-box__header {
		padding: 14px 14px 8px;
	}

	.el-message-box__content {
		padding: 8px 14px 12px;
	}

	.el-message-box__btns {
		padding: 8px 14px 14px;
	}
}
</style>